/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_TitleInputs */

const he_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יצירת חשבון`)
};

const en_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your account`)
};

/**
* | output |
* | --- |
* | "Create your account" |
*
* @param {Auth_Signup_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_title = /** @type {((inputs?: Auth_Signup_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_signup_title(inputs)
	return en_auth_signup_title(inputs)
});